import type { EventRegistration } from './event-registration-core';
import type { EventRsvp } from './events';

export type EventAttendanceStatus = 'cancelled' | 'none' | 'pending' | 'registered';

export type EventAttendanceSummary = Readonly<{
  eventId: string;
  registration: EventRegistration | null;
  rsvp: EventRsvp | null;
  status: EventAttendanceStatus;
}>;

export type EventAttendee = Readonly<{
  avatarUrl: string | null;
  /** When the runner was checked in, or null if they have not been. */
  checkedInAt: string | null;
  fullName: string | null;
  id: string;
  /** True once a check-in row exists for this runner on the event. */
  isCheckedIn: boolean;
}>;

/** Split a roster into who has checked in and who is still missing. */
export function partitionAttendeesByCheckIn(attendees: readonly EventAttendee[]): {
  checkedIn: EventAttendee[];
  missing: EventAttendee[];
} {
  const checkedIn: EventAttendee[] = [];
  const missing: EventAttendee[] = [];
  for (const attendee of attendees) {
    (attendee.isCheckedIn ? checkedIn : missing).push(attendee);
  }
  return { checkedIn, missing };
}

export function isRegistrationGoing(registration: EventRegistration | null): boolean {
  return registration?.status === 'confirmed' || registration?.status === 'pending_payment';
}

export function attendanceStatusFor(
  registration: EventRegistration | null,
  rsvp: EventRsvp | null
): EventAttendanceStatus {
  if (registration?.status === 'confirmed' || rsvp?.status === 'going') {
    return 'registered';
  }
  if (registration?.status === 'pending_payment') {
    return 'pending';
  }
  if (registration?.status === 'cancelled' || rsvp?.status === 'cancelled') {
    return 'cancelled';
  }
  return 'none';
}

export function isAttendanceActive(status: EventAttendanceStatus): boolean {
  return status === 'registered' || status === 'pending';
}

export function hasAttendanceRecord(status: EventAttendanceStatus): boolean {
  return status !== 'none';
}
